export const EVENT_DATE = '21-25. juli'
